import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useBreakpointValue,
} from '@chakra-ui/react';
import { useUIStore } from '~/store/useUIStore';
import { EnhancedLoginForm } from '~/components/auth/components/EnhancedLoginForm';

export const EnhancedLoginModal = () => {
  const modals = useUIStore((state) => state.modals);
  const setModals = useUIStore((state) => state.setModals);
  const { isOpen, home, project, action, redirectTo, searchFilters, preventClose } =
    modals.enhancedLoginOpen;
  const modalSize = useBreakpointValue({ base: 'full', md: 'md' });

  const onClose = () => {
    if (preventClose) return;
    setModals({
      ...modals,
      enhancedLoginOpen: {
        isOpen: false,
        home: null,
        project: null,
        action: null,
        redirectTo: undefined,
      },
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      returnFocusOnClose={false}
      size={modalSize}
      closeOnOverlayClick={!preventClose}
      closeOnEsc={!preventClose}
    >
      <ModalOverlay />
      <ModalContent
        my={{ base: '0', md: 'auto' }}
        mt={{ base: '4', md: 'auto' }}
      >
        {!preventClose && <ModalCloseButton size="lg" />}
        <EnhancedLoginForm
          authHome={home || null}
          authProject={project || null}
          authAction={action || null}
          redirectTo={redirectTo}
          searchFilters={searchFilters}
        />
      </ModalContent>
    </Modal>
  );
};
